import { render } from "./Discover.vue?vue&type=template&id=2867abe4&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"

import "./Discover.vue?vue&type=style&index=0&id=2867abe4&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2867abe4"]])

export default __exports__